const escStagesLocale = {
  escStages: {
    groups: {
      eligibility: "Eligibility",
      estimate: "Quote",
      installation: "Installation",
      invoicing: "Invoicing",
    },
    labels: {
      NONE: "Not determined",
      NON_ESC: "Not eligible",
      ESC_BLANK: "Eligible",
      ESTIMATE_GENERATED: "Quote generated",
      ESTIMATE_SIGNED: "Quote signed",
      INSTALLATION_GENERATED: "Installation generated",
      INSTALLATION_SIGNED: "Installation signed",
      INVOICED: "Invoiced",
    },
    status: {
      determinationPending: "Awaiting determination",
      nonEligible: "Not ESC eligible",
      currentStep: "Current step: ",
      unknownStatus: "Unknown status",
    },
    legend: {
      completed: "Action completed",
      inProgress: "In progress",
      pending: "Not reached",
    },
    event: {
      user: "User",
      userId: "User {id}",
      system: "System",
      systemAction: "System action",
      userProfile: "Profile: {description}",
      userId_label: "ID: {id}",
      viewDetails: "View details",
      keys: "key",
      keys_plural: "keys",
    },
  },
};

export default escStagesLocale;
